import {CALL_API} from 'middleware/api';

import * as ActionTypes from '../Freebet.js';

export function getFreebet() {
    return (dispatch) => {
        return dispatch({
            type: ActionTypes.GET_FREEBET,
            [CALL_API]: {
                endpoint: '/api/gambler/freebet',
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_GET_FREEBET,
                    ActionTypes.FAILURE_GET_FREEBET
                ],
                credentials: true
            }
        });
    };
}

export function toggleFreebet(data) {
    return {type: ActionTypes.TOGGLE_FREEBET, data};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Freebet.js